// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3GLiL","dragIcon":"Choice_dragIcon__2WeCo","left":"Choice_left__3dJuO","input":"Choice_input__1D517"};